import React, { useEffect, useState, useCallback } from 'react';
import { Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const FastInput = React.memo(
  ({ name, type, value, onChange, disabled, className, ...props }) => {
    const [customValue, setCustomValue] = useState(value);

    const handleChange = useCallback(e => setCustomValue(e.target.value), []);

    useEffect(() => {
      const timeout = setTimeout(() => {
        if (onChange) {
          onChange(customValue);
        }
      }, 300);
      return () => clearTimeout(timeout);
    }, [customValue]);

    return (
      <Input
        type={type || 'text'}
        value={customValue ?? ''}
        disabled={disabled}
        onChange={handleChange}
        autoComplete="off"
        {...(className ? { className } : {})}
        {...(name ? { name } : {})}
        {...props}
      />
    );
  },
  (prev, next) => prev.value === next.value && prev.disabled === next.disabled && prev.className === next.className
);

export default FastInput;

FastInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};
